import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { getWindow } from './app/providers/window.provider';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { LayoutComponent } from './app/components/layout/layout.component';
import { RouterModule } from '@angular/router';
import { routes } from './app/app.routes';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(LayoutComponent, {
  providers: [
    importProvidersFrom(BrowserModule, RouterModule.forRoot(routes)),
    {
      provide: Window,
      useFactory: getWindow,
    },
  ],
}).catch((err) => console.error(err));
